<template>
  <div class="md-layout" style="">
    <div class="md-layout-item md-size-30">
      <md-card style="height: calc(100% - 60px);">
        <md-card-content>
          <div style="display: flex; padding-top: 12px;">
            <div style="padding-left: -26px;padding-right: 20px;font-weight: 600; line-height: 36px; min-width: 60px;">
              <!-- 所属服务 -->
              <div>
                <p>{{$I18n("server_type")}}</p>
              </div>
              <!-- 服务名称 -->
              <div>
                <p>{{"服务名称"}}</p>
              </div>
              <!-- 服务标志 -->
              <div>
                <p>{{"服务标志"}}</p>
              </div>
            </div>
            <div style="width: calc(100% - 80px);">
              <!-- 所属服务 -->
              <div style="margin-bottom: -9px;">
                <md-field>
                  <md-select v-model="searchForm">
                    <md-option v-for="item in srvList" :key="item.id" :value="item.id">{{item.name}}({{item.id}})</md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- 服务名称 -->
              <div style="line-height: 36px;">
                <p>{{srvName}}</p>
              </div>
              <!-- 服务标志 -->
              <div style="line-height: 36px;">
                <p>{{searchForm}}</p>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-70">
      <md-card >
        <md-card-content>
          <md-button @click="openCheck" class="md-primary md-info">
            <div style=" display: flex;line-height: 18px;">
              {{$I18n("save")}}
            </div>
          </md-button>
          <div>
            <md-field class="textareabox" style="border-radius: 8px;background: #eeeeee;">
              <md-textarea v-model="textareaInput" style="height: 70vh;max-height: unset;"/>
            </md-field>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal
      ref    = "modal"
      :title = "''"
      :large = "false"
      :right = "false"
      @submit= "modal_submit"
    >
      <template slot="body">
        <div >{{$I18n("is_sure_edit")}}</div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
// import { formatJsonForNotes } from "@/common/tools.js";
export default {
  data() {
    return {
      srvList: this.$Param.srvList.build(),
      searchForm   : "kdumh",
      textareaInput: "",
      // 弹窗相关
      openModal: false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    searchForm() {
      this.api_getPageData();
    },
  },
  computed: {
    srvName() {
      let item  = this.srvList.filter(item => item.id === this.searchForm)[0]
      if(item){
        return item.name
      }
      return ""
    },
  },
  methods: {
    // 获取页面信息
    api_getPageData(){
      this.$api.getSrvTemp({
        "type"  : this.searchForm, // 服务类型
        "format": "yaml", // 内容格式
        "content":""      // 内容
      })
      .then(this.$Then(res => {
        this.textareaInput = res.data.content;
      }))
      .catch(this.$Catch(this.$I18n("get_error"),() => {
        this.textareaInput = "";
      }))
    },
    openCheck(){
      this.$refs.modal.open();
    },
    // 隐藏 弹窗
    modal_classicModalHide () {
      this.$refs.modal.close();
    },
    // 提交表单
    modal_submit () {
      this.$api.setSrvTemp({
        "type"   : this.searchForm, // 服务类型
        "format" : "yaml", // 内容格式
        "content": this.textareaInput, // 内容
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"));
          this.modal_classicModalHide();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .textareabox{
    border: 1px solid #e9e9e9;
  }
</style>